export default (string) => {
    return string.replace(/&#(?:x([\da-f]+)|(\d+));/ig, (_, hex, dec) => {
        return String.fromCharCode(dec || +(`0x${  hex}`));
    });
};
